export default "__VITE_ASSET__Iy5O1mqd__"